import React, { useState } from 'react';
import { Search, Home, Smartphone, Zap, Info, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const StoreNavbar = () => {
  const [searchFocused, setSearchFocused] = useState(false);
  const location = useLocation();

  const menuItems = [
    { label: 'Início', href: '/', icon: Home },
    { label: 'Aplicativos', href: '/apps', icon: Smartphone },
    { label: 'Módulos', href: '/modulos', icon: Zap },
    { label: 'Sobre', href: '/sobre-nos', icon: Info },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] bg-white border-b border-slate-200 h-[60px] flex items-center px-6">
      <div className="max-w-7xl mx-auto w-full flex items-center justify-between">
        
        {/* Left Section: Logo & Brand */}
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-3 group">
            <img src="logo.png" alt="LUKOS" className="h-[42px] w-auto transition-transform group-hover:scale-105" />
            <div className="flex items-center gap-3">
               <div className="w-px h-6 bg-slate-300 mx-1" />
               <span className="text-[#0f172a] font-bold text-base tracking-tight">Aplicativos</span>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center ml-8 gap-1">
            {menuItems.map((item) => {
              const active = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`relative px-4 py-1.5 text-[14px] font-black transition-all ${
                    active 
                    ? 'text-[#690093]' 
                    : 'text-slate-500 hover:text-[#0f172a]'
                  }`}
                >
                  {item.label}
                  {active && (
                    <motion.div 
                      layoutId="activeTab"
                      className="absolute bottom-[-18px] left-4 right-4 h-0.5 bg-[#690093] rounded-full"
                    />
                  )}
                </Link>
              );
            })}
          </div>
        </div>

        {/* Right Section: Search & Actions */}
        <div className="flex items-center gap-6">
          <div className={`relative transition-all duration-300 ${searchFocused ? 'w-[400px]' : 'w-[280px]'} hidden lg:block`}>
            <Search 
              size={16} 
              className={`absolute left-4 top-1/2 -translate-y-1/2 transition-colors ${searchFocused ? 'text-[#690093]' : 'text-slate-400'}`} 
            />
            <input
              type="text"
              placeholder="Pesquisar aplicativos, módulos e muito mais"
              onFocus={() => setSearchFocused(true)}
              onBlur={() => setSearchFocused(false)}
              className="w-full bg-slate-100/80 border-transparent rounded-full py-2 pl-11 pr-5 text-sm font-medium placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-[#690093]/20 focus:bg-white focus:border-[#690093] transition-all"
            />
          </div>

          <button className="bg-[#690093] text-white px-5 py-2 rounded-full text-sm font-black hover:bg-[#500070] transition-all shadow-md active:scale-95">
             Entrar
          </button>
        </div>

      </div>
    </nav>
  );
};

export default StoreNavbar;
